import { removeModel } from '../api/remove'
import globalNotification from 'live/services/global-notification'
import getModels from '../api/getModels'

export default function(model) {
    return dispatch => {
        removeModel(model)
            .then(r => {
                globalNotification.success(`Model successfully removed: ${model}.`)
                getModels().then(models => {
                    dispatch({ type: 'REMOVE_MODEL_OK', msg: `Type: ${model}. Removido com sucesso`, models: models })
                })
            })

            .catch(error => {
                console.error(error)
                globalNotification.error(`Model couldn't be removed: ${model}. Reload the page and try again.`)
                // dispatch({ type: "REMOVE_MODEL_ERROR", msg: `Type: ${model}. Erro ao tentar remover` })
            })
    }
}
